import { Row } from '../../../../components/table';
import { ExtendedMessageType } from '../../../types';
import { MessageTypeCell } from './MessageTypeCell';
import { StatusCell } from './StatusCell';
import { SubscriptionActionCell } from './SubscriptionActionCell';
import { PolicyCell } from './PolicyCell';

type MessageTypeRowProps = {
  index: number;
  messageType: ExtendedMessageType;
};

export const MessageTypeRow = ({ index, messageType }: MessageTypeRowProps) => (
  <Row index={index}>
    <MessageTypeCell id={messageType.id} name={messageType.name} />
    <PolicyCell subscriptionPolicy={messageType.subscriptionPolicy} />
    <StatusCell messageType={messageType} />
    <SubscriptionActionCell messageType={messageType} />
  </Row>
);
